
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import pc from './pc/cursos.vue';
    import movil from './pc/cursos.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: { pc, movil }
    } )
    export default class Componente extends Vue
    {



    }
